<template lang="pug">
  Drawer#giftcard-balance-check(@hide="uiStore.hideOverlay()" ref="drawer")
    template(#header)
      .back-link(@click="drawer?.hide()")
        Icon(name="arrow-left")
        h5.title {{ __('Check Gift Card Balance') }}
    balance-check(
      @balance="gcBalance = $event"
    )
    template(#footer)
      .giftcard-balance-footer
        .row
          .text {{ __('Remaining Balance') }}
          .val {{ $rogue.currency(gcBalance) }}
        RogueButton(
          width="full"
          :text="__('Return to Page')"
          @click="drawer?.hide()"
        )
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'
import { useUIStore } from '@/js/stores/uiStore'
import balanceCheck from '@/js/pages/product/components/balance-check.vue'
import type Drawer from 'sisu/components/core/Drawer.vue'

const uiStore = useUIStore()
const drawer = useTemplateRef<InstanceType<typeof Drawer>>('drawer')

const gcBalance = ref<number | null>(null)
</script>

<style lang="scss" scoped>
#giftcard-balance-check:deep() {
  .drawer-container {
    max-width: 320px;
  }

  .drawer-header .h-right {
    display: none;
  }

  .drawer-footer {
    background-color: $color-gray-x-light;
  }

  .close {
    display: none;
  }

  .field-error {
    margin-top: $space-xxxs;
  }
}

.no-margin-bottom {
  &, &.field-error {
    margin-bottom: 0;
  }
}

.field-error {
  margin-bottom: $space-xs;

  :deep() {
    input.input-touched {
      border-color: $color-red;
    }
  }
}

.back-link {
  display: flex;
  cursor: pointer;

  .icon {
    height: $size-xxs;
    width: $size-xxs;
    margin: 2px 0;
  }
}

.title {
  margin: 0 0 0 $space-s;
  text-transform: uppercase;
  line-height: 1em;
}

.gc-placeholder {
  margin: $space-s;
}

.row {
  display: flex;
  justify-content: space-between;
  padding-bottom: $space-xs;
  margin-bottom: $space-s;
  border-bottom: $border-width-thin solid $color-gray-light;
}

.text {
  color: $color-black-light;
  font-size: $size-s;
}

.val {
  font-size: $size-xs;
  font-weight: $weight-bold;
}

.giftcard-balance-inner {
  .row {
    flex-direction: column;
    padding: $space-s;
    margin-bottom: 0;

    &.form {
      border-bottom: none;
    }
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.giftcard-balance-footer {
  padding: $space-s;
}
</style>

<style lang="scss" scoped target="app">
.platform-ios, .platform-android {
  #giftcard-balance-check:deep() {
    .drawer-container {
      max-width: 100vw;
    }
    .drawer-header .h-right {
      display: block;
    }
  }
  .back-link {
    .icon {
      display: none;
    }
    .title {
      margin: 0;
    }
  }
}
</style>
